import createReactComponent from '../createReactComponent';
export default createReactComponent('clock-record', 'IconClockRecord', [
  ['path', { d: 'M21 12.3a9 9 0 1 0 -8.683 8.694', key: 'svg-0' }],
  ['path', { d: 'M12 7v5l2 2', key: 'svg-1' }],
  ['path', { d: 'M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-2' }],
]);
